export default class FontSizeCalculator {
    constructor() {
        this.FONT_SIZES = wordpress_globals.font_sizes;
        this.MOBILE_WIDTH = 768;
        this.DESKTOP_WIDTH = 1340;
        this.stylesheet = null;
        this.calculate();
        let resizeFunction = () => { this.calculate() }
        window.addEventListener('resize', resizeFunction)
        // console.log(this.FONT_SIZES);
    }

    calculate() {
        if(this.shouldResize()) {
            let css = this.resizeFonts();
            // console.log("CSS: ", css);
            window.requestAnimationFrame(() => {
                if(this.stylesheet && this.stylesheet.remove) {
                    this.stylesheet.remove();
                    this.stylesheet = null;
                }
                let styleSheet = document.createElement("style");
                styleSheet.innerHTML = css;
                document.head.appendChild(styleSheet);
                this.stylesheet = styleSheet;
            })
        } else {
            if(this.stylesheet && this.stylesheet.remove) {
                window.requestAnimationFrame(() => {
                    this.stylesheet.remove();
                    this.stylesheet = null;
                });
            }
        }
    }

    /**
     * Determining whether we should apply the font size calculations to the
     * fonts, only if we are between mobile and desktop.
     * @return {boolean} Whether to apply calculations to the fonts
     */
    shouldResize() {
        let width = document.body.clientWidth;
        if(width > this.MOBILE_WIDTH && width < this.DESKTOP_WIDTH) {
            return true;
        } else {
            //code to remove the styles here.
        }

        return false;
    }

    /**
     * Going through each of the fonts saved and calculating each based on
     * the current screen size.
     * @return {string} The CSS to apply.
     */
    resizeFonts() {
        let css = "";
        Object.keys(this.FONT_SIZES).forEach(key => {
            let font = this.FONT_SIZES[key];
            // console.log(key + " is ", font);

            //ensuring both a mobile and desktop array are present before doing any calculations.
            if(!font[0] || !font[1]) {
                console.warn('FontSizeCalculator - Font size shound contain both' +
                    ' a desktop and mobile font else nothing will happen for: ' + key);
            }


            let desktopFont = this.getFontData(font[0]);
            let mobileFont = this.getFontData(font[1]);
            let newFontSize = this.calculateFontSize(desktopFont.fontSize, mobileFont.fontSize);
            let newLineHeight = this.calculateLineHeight(desktopFont.lineHeight, mobileFont.lineHeight);
            if(newFontSize || newLineHeight) {
                let tempCSS = `${key} {`
                if(newFontSize) {
                    tempCSS += `font-size: ${newFontSize / 10}rem;`;
                }
                if(newLineHeight) {
                    tempCSS += `line-height: ${newLineHeight / 10}rem;`;
                }
                tempCSS += `}\n`

                css += tempCSS;
            }
            //console.log("New Font Size: ", newFontSize);
            //console.log("New Line Height: ", newLineHeight);
        });

        return css;
    }

    /** *
     * Getting the font size and line height for either the desktop or mobile font
     * @param {Array|number} font the desktop or mobile font to extract the data from
     * @return {{fontSize: number, lineHeight: number}} the raw, uncalculated line height and font size
     */
    getFontData(font) {
        let fontSize = null;
        let lineHeight = null;

        if(Array.isArray(font)) {
            fontSize = parseInt(font[0]);
            fontSize = (!isNaN(fontSize)) ? fontSize : null;

            if(font[1]) {
                lineHeight = parseInt(font[1]);
                lineHeight = (!isNaN(lineHeight)) ? lineHeight : null;
            }
        }

        if(typeof font === 'number') {
            fontSize = font;
        }

        return {
            fontSize: fontSize,
            lineHeight: lineHeight,
        }
    }


    calculateFontSize(desktopFontSize, mobileFontSize) {
        if(desktopFontSize && mobileFontSize) {
            return this.formulateSize(desktopFontSize, mobileFontSize);
        }

        return null;
    }

    calculateLineHeight(desktopLineHeight, mobileLineHeight) {
        if(desktopLineHeight && mobileLineHeight) {
            return this.formulateSize(desktopLineHeight, mobileLineHeight);
        }

        return null;
    }

    formulateSize(desktopSize, mobileSize) {
        const CURR_WIDTH = document.body.clientWidth;
        // console.log("Current Screen Size: " + CURR_WIDTH);

        //difference between mobile and desktop font sizes.
        let sizeDiff = desktopSize - mobileSize;

        //the difference between the minimum desktop size and the maximum mobile size
        //the sizes between mobile and desktop.
        let maxScreenDiff = this.DESKTOP_WIDTH - this.MOBILE_WIDTH;

        //the difference between the current screen size and the mobile width
        let currScreenDiff = CURR_WIDTH - this.MOBILE_WIDTH;

        //the new font size
        return Math.round(desktopSize - (((maxScreenDiff - currScreenDiff) / maxScreenDiff) * sizeDiff));
    }
}
